import React, { useEffect, useState } from "react";

interface Props {
    options: { label?: string; value?: string }[];
    name: string;
    placeholder: string;
    label?: string;
    defaultValue?: string | number;
    className?: string;
    updateChange?: (value: any) => void;
    validate?: {
        check?: boolean;
        data: { status?: boolean; message?: string };
    };
    noEmpty?: boolean;
    container?: boolean;
    disabled?: boolean;
    hideLabel?: boolean;
    required?: boolean;
}

const Select: React.FC<Props> = ({
    options,
    name,
    placeholder,
    label,
    defaultValue,
    updateChange,
    className,
    validate = {
        check: false,
        data: { status: true, message: "" },
    },
    noEmpty,
    container = true,
    disabled = false,
    hideLabel = true,
    required = false,
}) => {
    const [value, setValue] = useState<any>("");

    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue || "");
        }
    }, []);

    return (
        <div className={container ? "input-container " + (className ? className : "") : className}>
            <label className={hideLabel ? "d-none" : "input-label"}>{placeholder}</label>
            <select
                disabled={disabled}
                id={name}
                name={name}
                value={defaultValue}
                onChange={(e) => {
                    setValue(e.target.value);
                    if (updateChange) updateChange(e.target.value);
                }}
                className={`${validate.check ? (validate.data.status ? "" : "error") : ""} ${required && value.length === 0 ? "error" : ""}`}
            >
                {noEmpty ? <></> : <option value="">{placeholder}</option>}
                {(options || []).map((data, i) => {
                    // if (!options) {
                    // 	return <option></option>;
                    // }
                    if (Object.keys(data || {}).length !== 0) return <option key={i} value={data.value} dangerouslySetInnerHTML={{ __html: data.label || "" }}></option>;
                })}
            </select>
            <div className={validate.data.message !== "" ? "small red" : "d-none"}>{validate.data.message}</div>
            {/* <label htmlFor={name} className="input-label">
				{label || placeholder}
			</label> */}
        </div>
    );
};

export default Select;
